import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import VehicleTypeService from "../../services/vehicletype.service";

/* =================== Thunks =================== */

export const getvehicleType = createAsyncThunk(
  "vehicleType/getvehicleType",
  async (params, thunkAPI) => {
    try {
      const response = await VehicleTypeService.getvehicleType(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addvehicleType = createAsyncThunk(
  "vehicleType/addvehicleType",
  async (data, thunkAPI) => {
    try {
      const response = await VehicleTypeService.addvehicleType(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const updatevehicleType = createAsyncThunk(
  "vehicleType/updatevehicleType",
  async (payload, thunkAPI) => {
    try {
      const response = await VehicleTypeService.editvehicleType(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const deletevehicleType = createAsyncThunk(
  "vehicleType/deletevehicleType",
  async (id, thunkAPI) => {
    try {
      await VehicleTypeService.deletevehicleType(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* =================== State =================== */

const initialState = {
  loading: false,
  error: null,
  vehicleTypeList: [],
  updateSuccess: false,
};

/* =================== Slice =================== */ 

const vehicleTypeSlice = createSlice({
  name: "vehicleType",
  initialState,
  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder

      /* ---------- Get ---------- */
      .addCase(getvehicleType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getvehicleType.fulfilled, (state, action) => {
        state.loading = false;
        state.vehicleTypeList = action.payload?.vehicles || [];
      })
      .addCase(getvehicleType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Add ---------- */
      .addCase(addvehicleType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addvehicleType.fulfilled, (state, action) => {
        state.loading = false;
        const newHotel =
          action.payload?.data ||
          action.payload?.vehicleTypeData ||
          action.payload;

        if (newHotel) {
          state.vehicleTypeList.unshift(newHotel);
        }
      })
      .addCase(addvehicleType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Update ---------- */
      .addCase(updatevehicleType.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(updatevehicleType.fulfilled, (state, action) => {
        state.loading = false;
        state.updateSuccess = true;

        const updated =
          action.payload?.data || action.payload?.vehicleTypeData;

        if (updated?._id) {
          const index = state.vehicleTypeList.findIndex(
            (item) => item._id === updated._id
          );
          if (index !== -1) {
            state.vehicleTypeList[index] = updated;
          }
        }
      })
      .addCase(updatevehicleType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Delete ---------- */
      .addCase(deletevehicleType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletevehicleType.fulfilled, (state, action) => {
        state.loading = false;
        state.vehicleTypeList = state.vehicleTypeList.filter(
          (item) => item._id !== action.payload
        );
      })
      .addCase(deletevehicleType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateStatus } = vehicleTypeSlice.actions;
export default vehicleTypeSlice.reducer;
